import React, { useContext, useEffect, useState } from "react";
import { useHistory, withRouter } from "react-router-dom";
import PropTypes from "prop-types";

import menuItems from "../../core/menus/menuItems";
import MainItem from "./mainItem";
import {
    MenuFooter,
    MenuItems,
    Settings,
    MenuContainer,
    Logout,
    SettingIcon,
    NavigationBar,
    SettingsWrapper
} from "./style";
import settings from "../../assets/images/settings.svg";
import { LOGIN } from "../../core/routes/constants";
import GeneralSettings from "../Settings/GeneralSettings";
import { GET_STORAGE, REMOVE_STORAGE } from "../../core/utils";
import { LanguageContext } from "../../core/store";

const Menu = ({ isActive, toggleGeneralSettingsPopup }) => {

    const { translate } = useContext(LanguageContext);

    const [menuList, setMenuList] = useState({});
    const [openGeneralSettings, setOpenGeneralSettings] = useState(false);
    let history = useHistory();

    const handleClick = (menuId) => {
        menuList &&
        Object.keys(menuList).map((id) => {
            if (id !== menuId && !menuId.includes(id)) {
                setMenuList((menuList[id] = false));
            }
        });

        setMenuList({
            ...menuList,
            [menuId]: !menuList[menuId]
        });
    };

    const logOut = () => {
        const isLogin = GET_STORAGE("is_loggedIn");
        if (isLogin) {
            REMOVE_STORAGE("user");
            REMOVE_STORAGE("is_loggedIn");
            REMOVE_STORAGE("settings");
            history.push(LOGIN);

            // Kullanıcı çıkış yaptıktan sonra raporlama işlemini bitirmek için istek atıyoruz.
            /*
            TODO: API 404 verdiği için kapatıldı. API hazırlandığında kodlar açılacak
            sendAnalytics("logout").then(() => {
                REMOVE_STORAGE("user");
                REMOVE_STORAGE("is_loggedIn");
                REMOVE_STORAGE("settings");
                history.push(LOGIN);
            });*/
        }
    };

    const toggleSettingsPopup = () => {
        setOpenGeneralSettings(!openGeneralSettings);
        toggleGeneralSettingsPopup(openGeneralSettings);
    };

    useEffect(() => {
        setMenuList({});
    }, [isActive]);

    return (
        <NavigationBar isActive={isActive}>
            <MenuContainer>
                {menuItems.map((item, index) => (
                    <MenuItems key={item.path}>
                        <MainItem menuId={`menu-${index}`} handleClick={handleClick} menuList={menuList} {...item} />
                    </MenuItems>
                ))}
            </MenuContainer>

            <MenuFooter>
                <SettingIcon src={settings} />
                <Settings onClick={toggleSettingsPopup}>{translate("utils.generalSettings")}</Settings>
                {openGeneralSettings && (
                    <SettingsWrapper>
                        <GeneralSettings handleClosePopup={toggleSettingsPopup} />
                    </SettingsWrapper>
                )}
                <Logout onClick={logOut}>{translate("utils.logOut")}</Logout>
            </MenuFooter>
        </NavigationBar>
    );
};

Menu.propTypes = {
    isActive: PropTypes.bool.isRequired,
    toggleGeneralSettingsPopup: PropTypes.func.isRequired
};

export default withRouter(Menu);
